<template>
    <div class="wrap">
        <router-link v-if="!resp" :to="{name: 'users.edit', params: {id: user.id}}" class="list-item card">
            <div class="header">
                <h3>
                    {{ prettyName }}
                </h3>
                <svg class="icon" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                </svg>
            </div>
            <div class="no-certificate" v-if="!user.medical_certificate">
                Certificat médical manquant
            </div>
            <div v-if="hasNoCourses" class="no-class">
                <span>Aucun cours</span>
                <uni-cta-link v-if="!disabled && isSubscriptionOpen" :to="{name: 'classes.new', params: {id: user.id}}"
                              class="uni-cta-link--secondary uni-cta-link--small"
                >
                    Inscrire à un cours
                </uni-cta-link>
            </div>
            <div v-else>
                <div v-if="user.current_courses.length > 1">
                    Inscrit à {{ user.current_courses.length }} cours.
                </div>
                <div v-else>
                    Inscrit au cours de {{ user.current_courses[0].name }}
                </div>
            </div>
        </router-link>
        <div class="list-item card" v-else>
            <div class="header">
                <h3>
                    {{ prettyName }}
                </h3>
                <div v-if="count > 1" @click="emit(user)" class="icon resp">
                    <uni-circular-loader v-if="loading"></uni-circular-loader>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
                        <path d="M0 0h24v24H0z" fill="none"/>
                    </svg>
                </div>
            </div>
            <div class="resp-infos">
                <p><a :href="'mailto:'+user.email">{{user.email}}</a></p>
                <p><a :href="'tel:'+user.tel">{{$formatTel(user.tel)}}</a></p>
                <p>{{user.street}},</p>
                <p>{{user.postal_code}} {{user.city.toUpperCase()}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import UniCtaLink from "./UniCtaLink";
    import UniLink from "./UniLink";
    import UniCircularLoader from "./UniCircularLoader";
    import {mapGetters} from "vuex";

    export default {
        name: "RichPeopleListItem",
        components: {UniCircularLoader, UniLink, UniCtaLink},
        props: {
            user: Object,
            resp: Boolean,
            count: {
                type: Number,
                default: 0
            },
            disabled: Boolean
        },
        data() {
            return {
                prettyName: '',
                loading: false
            }
        },
        computed: {
            hasNoCourses() {
                return this.user.current_courses.length === 0
            },
            ...mapGetters({isSubscriptionOpen: 'isSubscriptionOpen'})
        },
        methods: {
            generatePrettyName() {
                this.prettyName = this.$sexyName(this.user.firstname, this.user.name)
            },
            emit(model) {
                this.loading = true
                this.$emit('deleteResp', model)
            }
        },
        created() {
            this.generatePrettyName()
        }
    }
</script>

<style scoped lang="scss">
    .wrap {
        width: 100%;
    }

    .list-item {
        width: 100%;

        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }

    .no-certificate {
        color: var(--color-warning-dark);
        margin: 12px 0;
        position: relative;
    }

    .no-class {
        margin-top: 1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        > span {
            white-space: nowrap;
        }

        > *:last-child {
            width: auto;
        }
    }

    .resp-infos {
        > p {
            margin-top: .5rem;
            margin-bottom: 0;
        }

    }

    @include screen-m {
        .no-class {
            > span {
                margin-right: 24px;
            }
        }
        .icon {
            display: none;
        }

        .icon.resp {
            display: block;
            cursor: pointer;
        }
    }

</style>
